import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=5319b20e&scoped=true&lang=html"
import script from "./countries.vue?vue&type=script&lang=js"
export * from "./countries.vue?vue&type=script&lang=js"
import style0 from "./countries.vue?vue&type=style&index=0&id=5319b20e&prod&lang=css"
import style1 from "./countries.vue?vue&type=style&index=1&id=5319b20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319b20e",
  null
  
)

export default component.exports